import { render, staticRenderFns } from "./MailActivity.vue?vue&type=template&id=4af4df84&"
import script from "./MailActivity.vue?vue&type=script&lang=js&"
export * from "./MailActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports